import * as React from 'react';
import {WithTranslation, withTranslation} from 'react-i18next';
import {Link} from 'gatsby';

import * as styles from './languageToggle.module.scss';

import type {Translations} from '@src/i18n';

export interface LanguageToggleProps extends WithTranslation<'LanguageToggle'> {
  className?: string;
  translations: Translations[];
}

const LanguageToggle = ({
  translations,
  t,
  i18n,
  className,
}: LanguageToggleProps) => {
  // Need at least one translation for this page to render the toggle.
  if (!translations || translations.length < 2) {
    return null;
  }

  const linkStyle = className || styles.link;

  return (
    <span className={styles.wrapper}>
      {translations
        // Only show alternate language translations.
        .filter(trans => trans.lang.code !== i18n.language)
        .map(trans => {
          const changeLanguage = () => i18n.changeLanguage(trans.lang.code);
          return (
            <Link
              key={trans.lang.code}
              className={linkStyle}
              to={trans.href}
              onClick={changeLanguage}
              aria-label={t('linkLabel', {language: trans.lang.name})}>
              {trans.lang.label}
            </Link>
          );
        })}
    </span>
  );
};

export default withTranslation('LanguageToggle')(LanguageToggle);
